import { ActionType, createAction, createAsyncAction } from "typesafe-actions";

import Identified from "@mapmycustomers/shared/types/base/Identified";
import { EntityType } from "@mapmycustomers/shared/types/entity";

import { UserRecentPayload } from "@app/types/userRecent/UserRecent";

import GlobalSearchItem, { GlobalSearchEntity } from "../../types/globalSearch/GlobalSearchItem";

export const showGlobalSearch = createAction("@globalSearch/showGlobalSearch")<void>();

export const hideGlobalSearch = createAction("@globalSearch/hideGlobalSearch")<void>();

export const fetchUserRecents = createAsyncAction(
  "@globalSearch/fetchUserRecents/request",
  "@globalSearch/fetchUserRecents/success",
  "@globalSearch/fetchUserRecents/failure"
)<void, GlobalSearchItem[], unknown>();

export const addUserRecent = createAction("@globalSearch/addUserRecent")<UserRecentPayload>();

export const clickOnGlobalSearchItem = createAction("@globalSearch/clickOnGlobalSearchItem")<{
  entity: GlobalSearchEntity;
  entityId: Identified["id"];
  entityType: EntityType;
}>();

export const performSearch = createAsyncAction(
  "@globalSearch/performSearch/request",
  "@globalSearch/performSearch/success",
  "@globalSearch/performSearch/failure"
)<{ entityTypes?: EntityType[]; query: string }, GlobalSearchItem[], unknown>();

export const resetActiveQuery = createAction("@globalSearch/resetActiveQuery")<void>();

export type Actions = ActionType<
  | typeof addUserRecent
  | typeof clickOnGlobalSearchItem
  | typeof fetchUserRecents
  | typeof hideGlobalSearch
  | typeof performSearch
  | typeof resetActiveQuery
  | typeof showGlobalSearch
>;
